import Messenger from '@/api/messenger'

const handlers = {
  'messages:created': ({ commit }, data) => commit('skiliko/messages/appendItem', {
    item: data,
    scope: {
      conversationId: data.conversation,
      page: 1
    }
  }, { root: true }),
  'messages:updated': ({ commit }, data) => commit('skiliko/messages/updateItem', { item: data }, { root: true }),
  'conversations:update': ({ commit }, data) => {
    commit('skiliko/conversations/appendItem', {
      item: data,
      scope: {
        page: 1,
        userId: [data.from, data.to].filter(e => e.scope === 'admin')[0]._id
      }
    }, { root: true })
    commit('skiliko/conversations/updateItem', { item: data }, { root: true })
  },
  'purchase:update': ({ dispatch }, data) => {
    dispatch('skiliko/purchases/fetch', JSON.parse(data), { root: true })
  }
}

let init = false

export default {
  namespaced: true,
  actions: {
    init: (store) => {
      if (init) return
      init = true
      const user = store.rootGetters['skiliko/session/currentUser']
      return Messenger.init(user.chatable_id)
        .then(socket => {
          Object.keys(handlers)
            .forEach(event => {
              socket.on(event, data => handlers[event](store, data))
            })
          store.dispatch('skiliko/messages/fetchPending', {}, { root: true })
        })
        .catch(error => console.debug('error', error))
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/skiliko/chat/index.js